/**
 * What a day card shows (#132, 1.117.0) -- the browser's copy of
 * `DayCards::DISPLAYS`, `showsPicture()` and `showsNumbers()` on the server.
 *
 * From use: "nur Video/Bild oder nur Zahlen". `both` is the card as it always
 * was; `map` is the picture or the film without the numbers; `numbers` is the
 * card without a picture. The chat, the browser book and the sheet ask these
 * two questions and nothing else; PDF and EPUB ask the server's.
 */
export type DayCardDisplay = 'both' | 'map' | 'numbers'

export const DAY_CARD_DISPLAYS: readonly DayCardDisplay[] = ['both', 'map', 'numbers']

/** Whether a card with this display carries a picture or a film. */
export function showsPicture(display: DayCardDisplay): boolean {
  return display !== 'numbers'
}

/** Whether the numbers stand on the card; a card from before 1.117.0 has no field and shows them. */
export function showsNumbers(card: { display?: DayCardDisplay }): boolean {
  return (card.display ?? 'both') !== 'map'
}
